import { RootState } from "@/store";
import { getTenantFromHash, lightenHex } from "@/utils/getBrandings";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const brand = useSelector((s: RootState) => s.branding);
  const { currentStep } = useSelector((state: RootState) => state.wizard);

  const partner = getTenantFromHash();

  const handleGetHelpClick = () => {
    if (location.pathname === "/help") {
      return;
    }

    navigate("/help", {
      state: {
        from: location.pathname + location.search,
        wizardStep: currentStep,
      },
    });
  };
  const brandName = partner ? window.partner?.title : "Sootchy";
  return (
    <>
      <footer className="font-outfit">
        <div className="container flex space-x-[32px] mx-auto text-[#C6C6C6] text-[14px] leading-[127%] py-[32px] px-4">
          <p>© {`${brandName} Inc. All Rights Reserved.`}</p>
          <button
            onClick={handleGetHelpClick}
            className={classNames(
              "underline cursor-pointer bg-transparent border-none p-0 text-brand",
            )}
          >
            Get Help
          </button>
        </div>
        <div>
          <div
            style={{
              background: partner
                ? lightenHex(window.partner?.colors?.primary, 0.6)
                : "var(--sootchy-brand-accent)",
            }}
            className={classNames(
              "h-[16px] w-full  border-t-[1.5px] border-black",
            )}
          ></div>
          <div
            className={classNames(
              `h-[16px] w-full border-t-[2px] border-black`,
              "bg-brand-default",
            )}
          ></div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
